export default "__VITE_ASSET__BkMmLvtP__"